import React, { PropTypes, PureComponent } from 'react';

import { labelActive, container, label, country as countryStyle } from './styles.module.css';

class PlacepickerPreset extends PureComponent {
  handleChange = () => {
    const {
      locationName,
      lat,
      lng,
      onClick,
    } = this.props;

    onClick({
      target: {
        name: 'location',
        value: {
          name: locationName,
          types: ['locality', 'political'],
          geometry: {
            location: {
              lat: () => { return lat; },
              lng: () => { return lng; },
            },
          },
        },
      },
      type: 'change',
    });
  }

  render() {
    const { locationName, countryName, className, selectedLocation } = this.props;

    return (
      <div className={[container, className].join(' ')}>
        <label
          className={selectedLocation === locationName ? labelActive : label}
          htmlFor={locationName}
          onClick={this.handleChange}
        >{locationName}<span className={countryStyle}>{countryName}</span>
          <input
            id={locationName}
            type="hidden"
            onClick={this.handleChange}
            value={locationName}
            ref={(node) => { this.input = node; }}
          />
        </label>
      </div>
    );
  }
}

export default PlacepickerPreset;

PlacepickerPreset.propTypes = {
  /**
   * String class names to append to component styles.
   */
  className: PropTypes.string,
  /**
   * String country that place resides in.
   */
  countryName: PropTypes.string,
  /**
   * Function called on place select.
   */
  onClick: PropTypes.func.isRequired,
  /**
   * String name of location (e.g. Kettering).
   */
  locationName: PropTypes.string.isRequired,
  /**
   * Latitude of location.
   */
  lat: PropTypes.number.isRequired,
  /**
   * Longitude of location.
   */
  lng: PropTypes.number.isRequired,
  /**
   * String name of currently selected location. Used to compare against
   * name of preset to determine whether option should be made bold.
   */
  selectedLocation: PropTypes.string,
};

PlacepickerPreset.defaultProps = {
  className: '',
  countryName: 'United Kingdom',
  lat: undefined,
  lng: undefined,
  selectedLocation: '',
};



// WEBPACK FOOTER //
// ./app/src/components/PlacepickerPreset/index.jsx